module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentfs",
    attrs: {
      "id": "ch00_fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEXUAL CULTURES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("General Editors: José Esteban Muñoz and Ann Pellegrini")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Times Square Red, Times Square Blue")]), _c('br'), _vm._v("Samuel R. Delany")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Private Affairs: Critical Ventures in"), _c('br'), _vm._v("the Culture of Social Relations")]), _c('br'), _vm._v("Phillip Brian Harper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("In Your Face: 9 Sexual Studies")]), _c('br'), _vm._v("Mandy Merck")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Tropics of Desire: Interventions"), _c('br'), _vm._v("from Queer Latino America")]), _c('br'), _vm._v("José Quiroga")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Murdering Masculinities: Fantasies of Gender"), _c('br'), _vm._v("and Violence in the American Crime Novel")]), _c('br'), _vm._v("Greg Forter")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Our Monica, Ourselves: The Clinton"), _c('br'), _vm._v("Affair and the National Interest")]), _c('br'), _vm._v("Edited by Lauren Berlant and Lisa Duggan")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Black Gay Man: Essays")]), _c('br'), _vm._v("Robert Reid-Pharr"), _c('br'), _c('em', [_vm._v("Foreword by Samuel R. Delany")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Passing: Identity and Interpretation"), _c('br'), _vm._v("in Sexuality, Race, and Religion")]), _c('br'), _vm._v("Edited by María Carla Sánchez"), _c('br'), _vm._v("and Linda Schlossberg")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("The Explanation for Everything:"), _c('br'), _vm._v("Essays on Sexual Subjectivity")]), _c('br'), _vm._v("Paul Morrison")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("The Queerest Art: Essays on"), _c('br'), _vm._v("Lesbian and Gay Theater")]), _c('br'), _vm._v("Edited by Alisa Solomon and Framji Minwalla")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Queer Globalizations: Citizenship"), _c('br'), _vm._v("and the Afterlife of Colonialism")]), _c('br'), _vm._v("Edited by Arnaldo Cruz Malavé"), _c('br'), _vm._v("and Martin F. Manalansan IV")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Queer Latinidad: Identity"), _c('br'), _vm._v("Practices, Discursive Spaces")]), _c('br'), _vm._v("Juana María Rodríguez")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Love the Sin: Sexual Regulation and"), _c('br'), _vm._v("the Limits of Religious Tolerance")]), _c('br'), _vm._v("Janet R. Jakobsen and Ann Pellegrini")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Boricua Pop: Puerto Ricans and the"), _c('br'), _vm._v("Latinization of American Culture")]), _c('br'), _vm._v("Frances Négron-Muntaner")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Manning the Race: Reforming Black"), _c('br'), _vm._v("Men in the Jim Crow Era")]), _c('br'), _vm._v("Marlon Ross")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("In a Queer Time and Place: Transgender"), _c('br'), _vm._v("Bodies, Subcultural Lives")]), _c('br'), _vm._v("Judith Halberstam")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Why I Hate Abercrombie and Fitch:"), _c('br'), _vm._v("Essays on Race and Sexuality")]), _c('br'), _vm._v("Dwight A. McBride")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("God Hates Fags: The Rhetorics"), _c('br'), _vm._v("of Religious Violence")]), _c('br'), _vm._v("Michael Cobb")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Once You Go Black: Choice, Desire, and"), _c('br'), _vm._v("the Black American Intellectual")]), _c('br'), _vm._v("Robert Reid-Pharr")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("The Latino Body: Crisis Identities in"), _c('br'), _vm._v("American Literary and Cultural Memory")]), _c('br'), _vm._v("Lázaro Lima")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Arranging Grief: Sacred Time and the"), _c('br'), _vm._v("Body in Nineteenth-Century America")]), _c('br'), _vm._v("Dana Luciano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Cruising Utopia: The Then and"), _c('br'), _vm._v("There of Queer Futurity")]), _c('br'), _vm._v("José Esteban Muñoz")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Another Country: Queer Anti-Urbanism")]), _c('br'), _vm._v("Scott Herring")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Extravagant Abjection: Blackness,"), _c('br'), _vm._v("Power, and Sexuality in the African"), _c('br'), _vm._v("American Literary Imagination")]), _c('br'), _vm._v("Darieck Scott")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Relocations: Queer Suburban Imaginaries")]), _c('br'), _vm._v("Karen Tongson")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Beyond the Nation: Diasporic Filipino"), _c('br'), _vm._v("Literature and Queer Reading")]), _c('br'), _vm._v("Martin Joseph Ponce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Single: Arguments for the Uncoupled")]), _c('br'), _vm._v("Michael Cobb")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfs"
  }, [_c('em', [_vm._v("Brown Boys and Rice Queens: Spellbinding"), _c('br'), _vm._v("Performance in the Asias")]), _c('br'), _vm._v("Eng-Beng Lim")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3204dc75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0